import Graphic from '@arcgis/core/Graphic';

export function getExtentShowingAllGraphics(graphics: Graphic[]) {
  const extents = graphics.filter(graphic => graphic.geometry.extent).map(graphic => graphic.geometry.extent);
  const extentUnion = extents.reduce((acc, extent) => {
    return acc.union(extent);
  });
  return extentUnion;
}
